function isMoneyOutput(value) {
    return typeof value?.amount === "string"
        && typeof value.currency === "string";
}

export function marketingDomainSpendReconciliation(audit) {
    const canonicalConnectedSpend = audit?.canonicalConnectedSpend;
    const coverageResidual = audit?.coverageResidual;

    if (!isMoneyOutput(canonicalConnectedSpend)
        || !isMoneyOutput(coverageResidual)
        || canonicalConnectedSpend.currency !== coverageResidual.currency) {
        return null;
    }

    return {canonicalConnectedSpend, coverageResidual};
}
